import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

export const subMenuOpen = (
  menu,
  items,
  submenuTimelines,
  { onDone, onIndicator } = {},
) => {
  const navItem = menu.closest(".nav-item");

  const menuControls = navItem.querySelector(".nav-item-control");
  const menuIcon = menuControls.querySelector(".nav-item-icon");
  const menuButton = navItem.querySelector(".nav-item-seeall");

  const key = menu.dataset.key || menu.id || navItem.dataset.slug;
  if (submenuTimelines.current[key]) submenuTimelines.current[key].kill();

  const tl = gsap.timeline();
  submenuTimelines.current[key] = tl;

  const targetHeight = menu.dataset.height || menu.scrollHeight;

  // fire indicator move 0.25s after open starts
  if (onIndicator) {
    tl.call(onIndicator, null, 0.65);
  }

  tl.to(menuIcon, { rotation: -180, duration: 0.75, ease: "power4.inOut" })
    .to(
      menu,
      {
        opacity: 1,
        height: targetHeight,
        duration: 0.5,
        ease: "power4.inOut",
        onComplete: () => {
          navItem.classList.add("nav-open");
        },
      },
      "<",
    )
    .to(
      items,
      { opacity: 1, duration: 0.75, ease: "power4.out", stagger: 0.1, y: 0 },
      "<+=.1",
    )
    .to(menuControls, { opacity: 1, duration: 0.25, ease: "power4.out" }, "<")
    .to(
      menuButton,
      { opacity: 1, duration: 0.25, ease: "power4.out", delay: 0.25 },
      ">",
    );

  if (onDone) {
    tl.call(onDone);
  }
};

export const subMenuClose = (
  menu,
  items,
  submenuTimelines,
  { onDone } = {},
) => {
  const navItem = menu.closest(".nav-item");

  const menuControls = navItem.querySelector(".nav-item-control");
  const menuIcon = menuControls.querySelector(".nav-item-icon");
  const menuButton = navItem.querySelector(".nav-item-seeall");

  const key = menu.dataset.key || menu.id || navItem.dataset.slug;
  if (submenuTimelines.current[key]) submenuTimelines.current[key].kill();

  const tl = gsap.timeline({
    onComplete: () => onDone?.(),
  });
  submenuTimelines.current[key] = tl;

  menuControls.removeAttribute("style");
  menuButton.removeAttribute("style");

  tl.to(menuIcon, { rotation: 0, duration: 0.75, ease: "power4.out" })
    .to(
      items,
      {
        opacity: 0,
        duration: 0.75,
        ease: "power4.out",
        stagger: 0.15,
        // y: 20,
        onComplete: () => {
          navItem.classList.remove("nav-open");
        },
      },
      "<",
    )
    .to(
      menu,
      { opacity: 0, height: 0, duration: 0.75, ease: "power4.out" },
      "<",
    );

  // if (!navItem.classList.contains("nav-open")) {
  //   tl.to(items, {
  //     opacity: 0,
  //     duration: 0.75,
  //     ease: "power4.out",
  //     stagger: 0.1,
  //     y: 20,
  //   })
  //     .to(menuIcon, { rotation: 0, duration: 0.25, ease: "power4.out" }, 0)
  //     .to(
  //       menu,
  //       { opacity: 0, height: 0, duration: 0.25, ease: "power4.out" },
  //       0,
  //     )
  //     .to(menuControls, { opacity: 0, duration: 0.1, ease: "power4.out" }, 0)
  //     .to(menuButton, { opacity: 0, duration: 0.1, ease: "power4.out" }, 0);
  // } else {
  //   tl.to(menuIcon, { rotation: 0, duration: 0.75, ease: "power4.out" })
  //     .to(
  //       items,
  //       {
  //         opacity: 0,
  //         duration: 0.75,
  //         ease: "power4.out",
  //         stagger: 0.1,
  //         y: 20,
  //         onComplete: () => {
  //           navItem.classList.remove("nav-open");
  //         },
  //       },
  //       "<",
  //     )
  //     .to(
  //       menu,
  //       { opacity: 0, height: 0, duration: 0.75, ease: "power4.inOut" },
  //       "<",
  //     );
  // }
};
